import keyMirror from 'keymirror';

export const ExperienceTypeConstants = keyMirror({
  EVENT: null,
  SEATED_EVENT: null,
  RESERVATION: null,
});

export const DEFAULT_CUTOFF_TIME = '23:45';
export const MAX_NAME_LENGTH = 80;
export const MAX_DESCRIPTION_LENGTH = 2048;

const RESERVATION_DESCRIPTION =
  'Add a regular reservation or a reservation type ' +
  'that showcases your craft with experiences like prix fixe tasting menus, kitchen table seating or omakase.';

const GA_EVENT_DESCRIPTION =
  'Works well for events that do not require assigned ' +
  'seating. No table setup available for this event type.';

const SEATED_EVENT_DESCRIPTION =
  'Best for events that require multiple seating times. ' +
  'Table assignments will need to be assigned in Timeline.';

export const ReservationOption = [
  {
    key: 'reservation',
    label: 'Reservation',
    subtext: RESERVATION_DESCRIPTION,
    value: ExperienceTypeConstants.RESERVATION as string,
  },
];
export const gaEventTypeOption = {
  key: 'event',
  label: 'General admission event',
  subtext: GA_EVENT_DESCRIPTION,
  value: ExperienceTypeConstants.EVENT as string,
};
export const seatedEventTypeOption = {
  key: 'seated-event',
  label: 'Reserved seating',
  subtext: SEATED_EVENT_DESCRIPTION,
  value: ExperienceTypeConstants.SEATED_EVENT as string,
};

export type RouteType = 'experiences' | 'events';
